import { useState } from 'react';
import { motion } from "framer-motion";
import { Container, Row, Col, Form, Table } from "react-bootstrap";

import question1_image from "../../../images/dog.jpg"
import question2_image from "../../../images/cat.jpg"
import question3_image from "../../../images/car.jpg"
import question4_image from "../../../images/cookie.jpg"
import recognition_ai from "../../../images/recognition_AI.png";


export default function StudyTwoInstructionSessionThree2( {onSubmit} ){
    const options = ['Dog','Cat','Car','Cookie'];
    const [selectedAnswers, setSelectedAnswers] = useState({
        question1: '',
        question2: '',
        question3: '',
        question4: ''
    });
    const correctAnswers = {
        question1: 'Dog',
        question2: 'Cat',
        question3: 'Car',
        question4: 'Cookie'
    };

    const [submitted, setSubmitted] = useState(false);
    const handleSelectChange = (questionKey, event) => {
        setSelectedAnswers({
            ...selectedAnswers,
            [questionKey]: event.target.value
        });
    };
    const handleSubmit = () => {
        setSubmitted(true);

        if(onSubmit){
            onSubmit();
        }
    };
    const allAnswered = Object.values(selectedAnswers).every(answer => answer !== '');
    const [showBubble, setShowBubble] = useState(false);

    const handleImageClick = () => {
        setShowBubble(true);
    };
    return (
        <Container className="study-item" style={{width:"90%"}}>
            <br />
            <Row>
            <h1 style={{ fontWeight: 'bold'}}>EAI datasets are controversial </h1>
                <Container>
                <p>We introduce <strong className='highlight'>Object recognition AI</strong> here! Select Four images from its dataset.</p> 
                {!submitted ? (
                        <>

                            <br />
                            <Row>
                                {[question1_image, question2_image, question3_image, question4_image].map((image_src, questionNumber) => (
                                    <Col key={`question${questionNumber+1}`} md={3} className="text-center">
                                        <img
                                                style={{
                                                    width: '180px',
                                                    height: '150px',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px'
                                                }}
                                            src={image_src} 
                                            alt={`Question ${questionNumber+1}`}
                                        />
                                        <p>Question {questionNumber + 1}</p>
                                        <Form.Group controlId={`emotionSelect${questionNumber+1}`}>
                                            <Form.Control
                                                as="select"
                                                value={selectedAnswers[`question${questionNumber+1}`]}
                                                onChange={(e) => handleSelectChange(`question${questionNumber+1}`, e)}
                                                className="form-select mt-3"
                                                style={{width:'100%'}}
                                            >
                                                <option value="">Select object</option>
                                                {options.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                ))}
                            </Row>
                            <div className="text-center mt-4">
                                <motion.button
                                    type="button"
                                    className={`button carousel-button ${allAnswered ? '' : 'button-disabled'}`}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.8 }}
                                    onClick={handleSubmit}
                                    disabled={!allAnswered}
                                >
                                    Submit
                                </motion.button>
                            </div>
                        </>
                    ) : (
                        <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={recognition_ai} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                                onClick={handleImageClick}
                            />
                        </Col>
                        <Col xs={7}>
                        {showBubble && (
                        <div className="chat-bubble">
                            <p>
                            It seems that people have no disagreement with the answers in my textbook.                   
                            </p>
                        </div>
                        )}
                        </Col>
                        </Row> 
                    )}
                    <br />
                {submitted && (
                    <div>
                        <h4>Summary</h4> 
                        <div className="mt-3" style={{textAlign:'center'}}>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <th><img src={question1_image} style={{ width: '120px', height: '90px', objectFit: 'cover' }} alt="question_one" /></th>
                                        <th><img src={question2_image} style={{ width: '120px', height: '90px', objectFit: 'cover' }} alt="question_two" /></th>
                                        <th><img src={question3_image} style={{ width: '120px', height: '90px', objectFit: 'cover' }} alt="question_three" /></th>
                                        <th><img src={question4_image} style={{ width: '120px', height: '90px', objectFit: 'cover' }} alt="question_four" /></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Answers</strong></td>
                                        {Object.keys(selectedAnswers).map((questionKey) => (
                                            <td key={questionKey}>{selectedAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td><strong className='highlight'>Labels</strong></td>
                                        {Object.keys(correctAnswers).map((questionKey) => (
                                            <td key={questionKey}>{correctAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </Table>
                        </div> 
                    </div>
                    )}
                </Container>
            </Row>
        </Container>
    );
};